<script setup>
import AnalysisLoadingOverlay from '@/components/saju-insight/common/AnalysisLoadingOverlay.vue';
import { useAnalysisSajuContext } from '@/composables/saju-insight/useAnalysisSajuContext';
const analysisContext = useAnalysisSajuContext();
/**
 * 낭만작명 결과 로딩/에러 상태 표시.
 * - 추천 모드는 LLM 동기 호출로 최대 ~130초 → long=true 로 긴 대기 안내.
 */
defineProps({
  loading: { type: Boolean, default: false },
  error: { type: String, default: '' },
  long: { type: Boolean, default: false },
});
const emit = defineEmits(['retry']);
</script>

<template>
  <div class="naming-result-state">
    <AnalysisLoadingOverlay
      v-if="loading && analysisContext"
      loading
      contained
      message="낭만작명 분석중입니다!"
      :description="long ? '사주를 분석해 이름을 짓고 있어요.\n결과가 나올 때까지 잠시만 기다려주세요.' : ''"
    />
    <template v-else-if="loading">
      <VProgressCircular indeterminate color="#724ce5" :size="48" :width="4" />
      <p class="naming-result-state__title">결과를 불러오는 중이에요</p>
      <p v-if="long" class="naming-result-state__desc">
        사주를 분석해 이름을 짓고 있어요.<br />
        최대 2분까지 걸릴 수 있어요.
      </p>
    </template>
    <template v-else-if="error">
      <p class="naming-result-state__title">{{ error }}</p>
      <button type="button" class="naming-result-state__retry" @click="emit('retry')">
        다시 시도
      </button>
    </template>
  </div>
</template>

<style scoped>
.naming-result-state {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 100%;
  min-height: 320px;
  padding: 40px;
  text-align: center;
  box-sizing: border-box;
}
.naming-result-state__title {
  margin: 0;
  color: #333;
  font-family: Pretendard;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;
}
.naming-result-state__desc {
  margin: 0;
  color: #757575;
  font-family: Pretendard;
  font-size: 14px;
  line-height: 1.5;
}
.naming-result-state__retry {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  background: #724ce5;
  color: #fff;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
</style>
